export enum ScenicStrollCategory {
    BOTANICAL = 'BOTANICAL',
    CANALSIDE = 'CANALSIDE',
    CLIFFTOP = 'CLIFFTOP',
    COASTAL = 'COASTAL',
    FOREST = 'FOREST',
    HARBOUR = 'HARBOUR',
    HILLY = 'HILLY',
    HISTORICAL = 'HISTORICAL',
    INDUSTRIAL = 'INDUSTRIAL',
    ISLAND = 'ISLAND',
    LAKESIDE = 'LAKESIDE',
    MOUNTAIN = 'MOUNTAIN',
    NATURE = 'NATURE',
    PANORAMIC = 'PANORAMIC',
    RIVERSIDE = 'RIVERSIDE',
    RURAL = 'RURAL',
    TRAIL = 'TRAIL',
    URBAN = 'URBAN',
    WETLAND = 'WETLAND',
}

export const SCENIC_STROLL_CATEGORY_LABELS: Record<ScenicStrollCategory, string> = {
    BOTANICAL: 'Botanical',
    CANALSIDE: 'Canalside',
    CLIFFTOP: 'Clifftop',
    COASTAL: 'Coastal',
    FOREST: 'Forest',
    HARBOUR: 'Harbour',
    HILLY: 'Hillside',
    HISTORICAL: 'Historic',
    INDUSTRIAL: 'Industrial',
    ISLAND: 'Island',
    LAKESIDE: 'Lakeside',
    MOUNTAIN: 'Mountain',
    NATURE: 'Nature',
    PANORAMIC: 'Panoramic',
    RIVERSIDE: 'Riverside',
    RURAL: 'Rural',
    TRAIL: 'Scenic',
    URBAN: 'Urban',
    WETLAND: 'Wetland',
};

export const SCENIC_STROLL_META_DESCRIPTIONS: Record<ScenicStrollCategory, string> = {
    [ScenicStrollCategory.BOTANICAL]: 'botanical gardens',
    [ScenicStrollCategory.CANALSIDE]: 'canalside walks',
    [ScenicStrollCategory.CLIFFTOP]: 'clifftop trails',
    [ScenicStrollCategory.COASTAL]: 'coastal paths',
    [ScenicStrollCategory.FOREST]: 'forest trails',
    [ScenicStrollCategory.HARBOUR]: 'harbour walks',
    [ScenicStrollCategory.HILLY]: 'hilly trails',
    [ScenicStrollCategory.HISTORICAL]: 'historic streets',
    [ScenicStrollCategory.INDUSTRIAL]: 'industrial heritage',
    [ScenicStrollCategory.ISLAND]: 'island walks',
    [ScenicStrollCategory.LAKESIDE]: 'lakeside walks',
    [ScenicStrollCategory.MOUNTAIN]: 'mountain trails',
    [ScenicStrollCategory.NATURE]: 'nature trails',
    [ScenicStrollCategory.PANORAMIC]: 'panoramic viewpoints',
    [ScenicStrollCategory.RIVERSIDE]: 'riverside walks',
    [ScenicStrollCategory.RURAL]: 'rural trails',
    [ScenicStrollCategory.TRAIL]: 'scenic trails',
    [ScenicStrollCategory.URBAN]: 'urban walks',
    [ScenicStrollCategory.WETLAND]: 'wetland walks',
};